<template>
  <div class="accesibilidad ">
      <button class="btn btn-primary" @click="EscalaGris()">
        <i class="fas fa-universal-access"></i>
      </button>
      <button class="btn btn-secondary" @click="fontSize()">
        <i class="fas fa-text-height"></i>
      </button>
      <button class="btn btn-secondary" @click="AltoContraste()">
        contraste
      </button>
      <button class="btn btn-secondary" @click="reset_accesibilidad()">
        reset
      </button>
  </div>
</template>
<script>
export default ({
  nam: 'componenteAccesibilidad',
  data: function() {
    return{
      gris: false,
      numero: 0,
      menu: false,
    }
  },
  methods:{
    EscalaGris(){
      let body = document.getElementById('principal--body');
      this.gris = !(this.gris);
      if(this.gris) body.className = 'filtoGris';
      else body.className = 'filtoColor';
    },

    fontSize(){
      if(this.numero<4) this.numero += 1;
      else this.numero = 0;
        let p = document.getElementsByTagName("p"),
            a = document.getElementsByTagName("a"),
            h1 = document.getElementsByTagName("h1"),
            h2 = document.getElementsByTagName("h2"),
            h3 = document.getElementsByTagName("h3"),
            h4 = document.getElementsByTagName("h4"),
            h5 = document.getElementsByTagName("h5"),
            h6 = document.getElementsByTagName("h6"),

            anchoNav = document.getElementById("anchoNav"),
            logoHacienda_div = document.getElementById("logoHacienda_div"),

            logoHacienda = document.getElementById("logoHacienda"),
            nav_item = document.getElementsByClassName("nav-link");

            // console.log('anchoNav', anchoNav);

        for (let i = 0; i < p.length; i++) {
          if(this.numero > 0) p[i].classList.remove('font'+(this.numero-1));
          if(this.numero == 0) p[i].classList.remove('font4');
          p[i].classList.add('font'+this.numero);
        }
        for (let i = 0; i < a.length; i++) {
          if(this.numero > 0) a[i].classList.remove('font'+(this.numero-1));
          if(this.numero == 0) a[i].classList.remove('font4');
          a[i].classList.add('font'+this.numero);
        }
        for (let i = 0; i < h5.length; i++) {
          if(this.numero > 0) h5[i].classList.remove('h1Font'+(this.numero-1));
          if(this.numero == 0) h5[i].classList.remove('h1Font4');
          h5[i].classList.add('h1Font'+this.numero);
        }
        for (let i = 0; i < h1.length; i++) {
          if(this.numero > 0) h1[i].classList.remove('h1Font'+(this.numero-1));
          if(this.numero == 0) h1[i].classList.remove('h1Font4');
          h1[i].classList.add('h1Font'+this.numero);
        }
        for (let i = 0; i < h4.length; i++) {
          if(this.numero > 0) h4[i].classList.remove('h1Font'+(this.numero-1));
          if(this.numero == 0) h4[i].classList.remove('h1Font4');
          h4[i].classList.add('h1Font'+this.numero);
        }

        /* cambio en el logo del navbar "secretaria de hacienda" */
        if(this.numero > 0){
          logoHacienda.classList.remove('font1');
          logoHacienda.classList.add('logoHacienda');
          anchoNav.classList.remove('container');
          anchoNav.classList.add('anchoNav');
          logoHacienda_div.classList.add('logoHacienda_div');

          for (let i = 0; i < nav_item.length; i++) {
            nav_item[i].classList.remove('font'+(this.numero-1));
            nav_item[i].classList.add('opcionesNav');
          }
        }else{
          logoHacienda.classList.add('font1');
          logoHacienda.classList.remove('logoHacienda');
          anchoNav.classList.remove('anchoNav');
          anchoNav.classList.add('container');
          logoHacienda_div.classList.remove('logoHacienda_div');

          for (let i = 0; i < nav_item.length; i++) nav_item[i].classList.remove('opcionesNav');

        }

        // console.log(this.numero);

    },

    AltoContraste(){
      this.menu = !this.menu;
      let navbar = document.getElementById("navbarPrincipal"),
      p = document.getElementsByTagName("p"),
      contrasteFondo = document.getElementById("contenedor_cards"),
      contrasteFondo2 = document.getElementById("contrasteFondo2"),
      sala_prensa = document.getElementById("sala_prensa"),
      // titulares = document.getElementsByClassName("nav-link"),
      social_section = document.getElementById("social_section"),
      prensaTitulo = document.getElementById("prensaTitulo"),
      prensaTitulo1 = document.getElementById("prensaTitulo1"),
      socialTitulo = document.getElementById("socialTitulo"),
      socialTitulo1 = document.getElementById("socialTitulo1");


      if(this.menu) navbar.style.backgroundColor="black";
      else navbar.removeAttribute('style');

      let classname = document.getElementsByClassName('nav-link');
      // console.log(classname[0]);
      for (let i = 0; i < classname.length; i++) classname[i].style.color="#fff";

      if(this.menu){
        contrasteFondo.id = 'contrasteFondo2';
        contrasteFondo.classList.add('contrasteFondo');

        sala_prensa.classList.add('contrasteFondo');
        sala_prensa.classList.remove('bg-color-light');

        social_section.style.backgroundColor="black";
        socialTitulo.classList.remove('color-negro1');
        socialTitulo.style.color="#fff";
        socialTitulo1.classList.remove('color-negro1');
        socialTitulo1.style.color="#fff";

        prensaTitulo.classList.remove('color-vino1');
        prensaTitulo.style.color="#fff";
        prensaTitulo1.classList.remove('color-vino1');
        prensaTitulo1.style.color="#fff";
      }
      else{
        contrasteFondo2.id = 'contenedor_cards';
        contrasteFondo2.classList.remove('contrasteFondo');

        sala_prensa.classList.remove('contrasteFondo');
        sala_prensa.classList.add('bg-color-light');

        social_section.style.backgroundColor="#fff";
        socialTitulo.classList.add('color-negro1');
        socialTitulo.removeAttribute('style');
        socialTitulo1.classList.add('color-negro1');
        socialTitulo1.removeAttribute('style');

        prensaTitulo.removeAttribute('style');
        prensaTitulo.classList.add('color-vino1');
        prensaTitulo1.removeAttribute('style');
        prensaTitulo1.classList.add('color-vino1');
      }

      for (let i = 0; i < p.length; i++) {
          if(this.numero > 0) p[i].classList.remove('font'+(this.numero-1));
          if(this.numero == 0) p[i].classList.remove('font4');
          p[i].classList.add('font'+this.numero);
        }


    },
    reset_accesibilidad(){
      let logoHacienda_div = document.getElementById("logoHacienda_div"),
          navbar = document.getElementById("navbarPrincipal"),
          p = document.getElementsByTagName("p"),
          logoHacienda = document.getElementById("logoHacienda"),
          anchoNav = document.getElementById("anchoNav"),
          nav_item = document.getElementsByClassName("nav-link"),
          contrasteFondo2 = document.getElementById("contrasteFondo2"),
          sala_prensa = document.getElementById("sala_prensa"),
          prensaTitulo = document.getElementById("prensaTitulo"),
          prensaTitulo1 = document.getElementById("prensaTitulo1"),
          a = document.getElementsByTagName("a"),
          h1 = document.getElementsByTagName("h1"),
          h2 = document.getElementsByTagName("h2"),
          h3 = document.getElementsByTagName("h3"),
          h4 = document.getElementsByTagName("h4"),
          h5 = document.getElementsByTagName("h5"),
          h6 = document.getElementsByTagName("h6");

      logoHacienda.classList.remove('logoHacienda');
      anchoNav.classList.remove('anchoNav');
      anchoNav.classList.add('container');
      logoHacienda_div.classList.remove('logoHacienda_div');
      navbar.removeAttribute('style');

      for (let i = 0; i < nav_item.length; i++) nav_item[i].classList.remove('opcionesNav');
      for (let i = 0; i < p.length; i++) p[i].classList.remove('font'+this.numero);
      for (let i = 0; i < h5.length; i++) h5[i].classList.remove('h1Font'+this.numero);
      for (let i = 0; i < a.length; i++) a[i].classList.remove('font'+this.numero);

      /* desactivo contraste en cardsPersianas y salaPrensa */
      if(this.menu){
        contrasteFondo2.id = 'contenedor_cards';
        contrasteFondo2.classList.remove('contrasteFondo');

        sala_prensa.classList.remove('contrasteFondo');
        sala_prensa.classList.add('bg-color-light');
        prensaTitulo.removeAttribute('style');
        prensaTitulo.classList.add('color-vino1');
        prensaTitulo1.removeAttribute('style');
        prensaTitulo1.classList.add('color-vino1');

        social_section.style.backgroundColor="#fff";
        socialTitulo.classList.add('color-negro1');
        socialTitulo.removeAttribute('style');
        socialTitulo1.classList.add('color-negro1');
        socialTitulo1.removeAttribute('style');

      }

      this.numero = 0;
      this.menu = false;


    }
  }
})
</script>
